// Which hero's sheet is open (HeroSheet.tsx), kept apart so any screen can open one without
// importing the sheet.
import { create } from 'zustand';

interface HeroSheetStore { heroId?: bigint; open(id: bigint): void; close(): void }

export const useHeroSheet = create<HeroSheetStore>()((set) => ({
  heroId: undefined,
  open: (id) => set({ heroId: id }),
  close: () => set({ heroId: undefined }),
}));

export const openHeroSheet = (id: bigint) => useHeroSheet.getState().open(id);
